import { useLanguage, t } from "../../../i18n";
import React from "react";
import "./InfoPill.css";
export default function InfoPill({
  label,
  value,
  translateValue = true
}) {
  useLanguage();
  return <div className="bb-info-pill">
      <span className="bb-info-pill__label">{t(label)}</span>
      <span className="bb-info-pill__value" dir="auto">{translateValue ? t(value) : value}</span>
    </div>;
}
